/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataAccessRule } from '../models/DataAccessRule';

export class Role {
  /**
  * The ID of the role
  */
  'id': string;
  /**
  * The name of the role
  */
  'name': string;
  /**
  * The scopes of the role
  */
  'scopes': Array<string>;
  /**
  * Whether the role is a project role
  */
  'isProjectRole'?: boolean;
  /**
  * Whether the role is built in
  */
  'isBuiltInRole': boolean;
  /**
  * The data access rules of the role, keyed by name
  */
  'dataAccessRules'?: { [key: string]: DataAccessRule; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "scopes",
      "baseName": "scopes",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "isProjectRole",
      "baseName": "isProjectRole",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isBuiltInRole",
      "baseName": "isBuiltInRole",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "dataAccessRules",
      "baseName": "dataAccessRules",
      "type": "{ [key: string]: DataAccessRule; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Role.attributeTypeMap;
  }

  public constructor() {
  }
}

